import React, { Component } from "react";
import { Link } from "react-router-dom";
import KheshtiRug from "./rugTemplates/kheshtiRug";
import AfshanRug from "./rugTemplates/afshanRug";
import LachakToranjRug from "./rugTemplates/lachakToranjRug";
import ModernRug from "./rugTemplates/modernRug";
export default class RugsWishListSidebar extends Component {
  render() {
    let wishList = [];

    this.props.wishList.map((rug, i) => {
      let key = rug.type + i;
      switch (rug.type) {
        case "lachak-toranj":
          wishList.push(
            <li className="check" key={key}>
              <LachakToranjRug
                background={rug.background}
                border={rug.border}
                corner={rug.corner}
                toranj={rug.toranj}
                show={true}
              />
            </li>
          );
          break;
        case "kheshti":
          wishList.push(
            <li className="check" key={key}>
              {/* <span> 23%</span> */}
              <KheshtiRug
                background={rug.background}
                tile={rug.tile}
                show={true}
              />
            </li>
          );
          break;
        case "modern":
          wishList.push(
            <li className="check" key={key}>
              {/* <span> 23%</span> */}
              <ModernRug
                background={rug.background}
                pattern={rug.pattern}
                show={true}
              />
            </li>
          );
          break;
        default:
          wishList.push(
            <li className="check active" key={key}>
              {/* <span> 23%</span> */}
              <AfshanRug
                background={rug.background}
                border={rug.border}
                show={true}
              />
            </li>
          );
          break;
      }
      return "";
    });
    return (
      <div className="text-center favorites-list-normal-display">
        <ul
          className="relative"
          style={{ display: "flex", justifyContent: "center" }}
        >
          {wishList.length === 0 && <li className="check"></li>}

          {wishList}
        </ul>
        {this.props.wishList.length > 0 && (
          <div
            className=" d-flex justify-content-center"
            style={{
              position: "absolute",
              bottom: window.innerWidth > 768 ? -110 : -32,
              right: "50%",
              left: "50%",
            }}
          >
            <Link
              to={{
                pathname: `/preview`,
                state: {
                  rugs: this.props.wishList,
                  page: this.props.activeTabs,
                },
              }}
            >
              <button
                className="btn-preview"
                style={{
                  width: 250,
                  backgroundColor: "#10bb6c",
                  fontWeight: 300,
                  fontSize: 12,
                }}
              >
                <span>{this.props.texts["preview"]}</span>
              </button>
            </Link>
          </div>
        )}
      </div>
    );
  }
}
